import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";
import { SingleInvitationPayload, SubmitSingleInvitationOptions } from "./InvitationModal.d";

export const submitSingleInvitation = (
  payload: SingleInvitationPayload,
  { setLoading, showAlert, popAlert, onSuccess, language }: SubmitSingleInvitationOptions
) => {
  setLoading(true);

  showAlert?.({
    type: "info",
    title: translate(language, "PAGES.INVITATIONS.INVITATION_MODAL.ALERTS.INFO.TITLE"),
    message: translate(language, "PAGES.INVITATIONS.INVITATION_MODAL.ALERTS.INFO.MESSAGE"),
    clickOutsideToClose: false,
    buttons: [],
  });

  ApiService.post("users/invite", {
    ...payload,
    module_ids: [],
    send_password_email: true,
  })
    .then(() => {
      popAlert?.();

      showAlert?.({
        type: "success",
        title: translate(language, "PAGES.INVITATIONS.INVITATION_MODAL.ALERTS.SUCCESS.TITLE"),
        message: translate(language, "PAGES.INVITATIONS.INVITATION_MODAL.ALERTS.SUCCESS.MESSAGE"),
        buttons: [
          {
            label: translate(language, "PAGES.INVITATIONS.INVITATION_MODAL.ALERTS.SUCCESS.BUTTON"),
            onClick: () => popAlert?.(),
          },
        ],
      });

      onSuccess?.();
    })
    .catch((err: any) => {
      popAlert?.();

      showAlert?.({
        type: "danger",
        title: translate(language, "PAGES.INVITATIONS.INVITATION_MODAL.ALERTS.ERROR.TITLE"),
        message: err?.data?.message || translate(language, "PAGES.INVITATIONS.INVITATION_MODAL.ALERTS.ERROR.MESSAGE"),
        buttons: [
          {
            label: translate(language, "PAGES.INVITATIONS.INVITATION_MODAL.ALERTS.ERROR.BUTTON"),
            onClick: () => popAlert?.(),
          },
        ],
      });
    })
    .finally(() => setLoading(false));
};
